/**
 * IAM response message configuration
 * @constant iamMessages
 * @type {object}
 * IAM response (success or error) ERROR messages, or custom messages, mapped to constants */

export const iamMessages = {
	EMAIL_ADDRESS_IN_USE: {
		message: 'EmailAddress is in use.',
		error: 'iam_register_email_in_use'
	},
	NO_USER_FOUND: {
		message: 'No user association found.',
		error: 'iam_email_check_no_user',
	},
	USER_FOUND: {
		message: 'iam_email_check_has_user',
	},
	INVALID_CREDENTIALS: {
		message: 'The username or password is incorrect.',
	},
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/config/iamMessages.js